import axios from "axios";

export async function getEducationCategory() {
    const cmsUrl = localStorage?.getItem("cmsUrl");
    const lang = localStorage.getItem("language");
    const headers = {
        // Authorization: "e01a4b78-d5ca-404e-a63c-7e8c032eeb38",
        Authorization: "6623bad3-9f9f-4a3d-bc74-3aee997f033a", // new
    };
    // new api example: https://cms.antospnc.asia/api/sections/getSectionCategory?section=education&lang=en
    return await axios({
        url: `https://cms.` + cmsUrl + `/api/sections/getSectionCategory?section=education&lang=${lang}`,
        method: "get",
        headers: headers,
    })
        .then((response) => {
            return response?.data;
        })
        .catch((e) => {
            console.error(e);
            throw e;
        });
}

export async function getEducationPosting() {
    const cmsUrl = localStorage?.getItem("cmsUrl");
    const lang = localStorage.getItem("language");
    const headers = {
        Authorization: "e01a4b78-d5ca-404e-a63c-7e8c032eeb38",
    };
    // new api dont have this getSectionPosting api
    return await axios({
        url: `https://cmsapi.` + cmsUrl + `/api/section/getSectionPosting?name=education&lang=${lang || "en"}`,
        method: "get",
        headers: headers,
    })
        .then((response) => {
            return response?.data;
        })
        .catch((e) => {
            console.error(e);
            throw e;
        });
}
